import { useEffect, useState } from 'react';

// useIsMobile — true cuando el viewport está por debajo del breakpoint dado
// (default 768px, alineado con `md:` de Tailwind). Listener con matchMedia,
// SSR-safe (default false hasta montar).
//
// Uso:
//   const isMobile = useIsMobile();
//   const isSmall = useIsMobile(640); // sm:
//
// IMPORTANTE: NO uses esto para tomar decisiones de layout que ya puedan
// resolverse con clases responsive de Tailwind (`md:`, `lg:`). Resérvalo
// para casos donde el render mismo depende del tamaño (e.g. cantidad de
// ticks en un timeline, modo de un componente que no acepta className).

export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const update = () => setIsMobile(mql.matches);
    update();
    if (mql.addEventListener) {
      mql.addEventListener('change', update);
      return () => mql.removeEventListener('change', update);
    }
    // Safari < 14 fallback
    mql.addListener(update);
    return () => mql.removeListener(update);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
